/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_Pcm_S24leInputs */



/**
* | output |
* | --- |
* | "PCM 24-bit" |
*
* @param {Audio_Embed_Export_Codec_Pcm_S24leInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_pcm_s24le = /** @type {((inputs?: Audio_Embed_Export_Codec_Pcm_S24leInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_Pcm_S24leInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("PCM 24 bits")
	if (locale === "de") return /** @type {LocalizedString} */ ("PCM 24-Bit")
	if (locale === "it") return /** @type {LocalizedString} */ ("PCM a 24 bit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("PCM 24-бит")
	if (locale === "es") return /** @type {LocalizedString} */ ("PCM de 24 bits")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("PCM 24 位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("PCM 24ビット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पीसीएम 24-बिट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("PCM de 24 bits")
	return /** @type {LocalizedString} */ ("PCM 24-bit")
});